import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is authenticated
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    navigate('/login');
  };

  return (
    <div className="dashboard-container">
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <div className="container-fluid">
          <span className="navbar-brand">KPM-Trizent Tab App</span>
          <div className="d-flex">
            <button
              className="btn btn-outline-light btn-sm me-2"
              onClick={() => navigate('/features')}
            >
              Features
            </button>
            <button
              className="btn btn-outline-light btn-sm"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>

      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <h3 className="card-title">Welcome to Dashboard</h3>
                <p className="card-text text-muted">
                  You have successfully logged in to the KPM-Trizent Tab Application.
                </p>
                <hr />
                <div className="row mt-4">
                  <div className="col-md-4 mb-3">
                    <div className="card bg-light">
                      <div className="card-body text-center">
                        <h5 className="card-title">Users</h5>
                        <p className="display-6">0</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card bg-light">
                      <div className="card-body text-center">
                        <h5 className="card-title">Reports</h5>
                        <p className="display-6">0</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card bg-light">
                      <div className="card-body text-center">
                        <h5 className="card-title">Activities</h5>
                        <p className="display-6">0</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <button
                    className="btn btn-primary"
                    onClick={() => navigate('/features')}
                  >
                    View All Features →
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
